import httpClient from './httpClient';
import {
  StoreDisplayGroupPlanogram,
  StoreDisplayGroupPlanogramFilters,
  PlanogramPaginationParams,
  StoreDisplayGroupDetailAlgorithm,
  StoreDisplayGroupDetailManual,
  PlanogramDetailFilters,
  ManualResultEditForm
} from '../types/storeDisplayGroupPlanogram';
import { ApiResponse, PaginatedResponse } from '../types/index';
import { getMockPlanogramData, getMockPlanogramByCode, getMockPlanogramDetail, getMockAlgorithmDetails, getMockManualDetails } from '../mock/storeDisplayGroupPlanogramData';
import { API_ENDPOINTS } from '../utils/apiEndpoints';
import { WHOLE_USE_MOCK } from './api';

// 是否使用Mock数据（开发环境）
const USE_MOCK = true; // 开发阶段使用Mock数据

class StoreDisplayGroupPlanogramService {
  private baseUrl = '/api/v1/store-display-group-planograms';

  /**
   * 获取Planogram列表（分页）
   */
  async getPlanogramList(
    filters: StoreDisplayGroupPlanogramFilters,
    pagination: PlanogramPaginationParams
  ): Promise<ApiResponse<PaginatedResponse<StoreDisplayGroupPlanogram>>> {
    if (USE_MOCK && WHOLE_USE_MOCK) {
      // 模拟网络延迟
      await new Promise(resolve => setTimeout(resolve, 500));
      return getMockPlanogramData(filters, pagination);
    }

    const params = {
      ...filters,
      page: pagination.page,
      currentPage: pagination.page,
      pageSize: pagination.pageSize,
      sortBy: pagination.sortBy,
      sortOrder: pagination.sortOrder
    };

    // 过滤掉undefined值
    Object.keys(params).forEach(key => {
      if (params[key as keyof typeof params] === undefined) {
        delete params[key as keyof typeof params];
      }
    });
    const res = await httpClient.post(API_ENDPOINTS.STORE_DISPLAY_GROUPS.PLANOGRAM.PAGE, params);

    return res.data;
  }

  /**
   * 根据code获取Planogram详情
   */
  async getPlanogramByCode(code: string): Promise<ApiResponse<StoreDisplayGroupPlanogram>> {
    if (USE_MOCK && WHOLE_USE_MOCK) {
      // 模拟网络延迟
      await new Promise(resolve => setTimeout(resolve, 300));
      return getMockPlanogramByCode(code);
    }

    const res = await httpClient.get(API_ENDPOINTS.STORE_DISPLAY_GROUPS.PLANOGRAM.QUERY_BY_CODE + "?code=" + code);
    return res.data;
  
  }
  // /**
  //  * 提交商业审批
  //  */
  // async submitCommercialApproval(code: string): Promise<ApiResponse<boolean>> {
  //   const res = await httpClient.post(`${this.baseUrl}/${code}/commercial-approval/submit`);
  //   return res.data;
  // }

  // /**
  //  * 商业审批通过
  //  */
  // async approveCommercial(code: string, comment?: string): Promise<ApiResponse<boolean>> {
  //   const res = await httpClient.post(`${this.baseUrl}/${code}/commercial-approval/approve`, { comment });
  //   return res.data;
  // }

  // /**
  //  * 商业审批拒绝
  //  */
  // async rejectCommercial(code: string, comment: string): Promise<ApiResponse<boolean>> {
  //   const res = await httpClient.post(`${this.baseUrl}/${code}/commercial-approval/reject`, { comment });
  //   return res.data;
  // }

  // /**
  //  * 提交制图审批
  //  */
  // async submitPlanogramApproval(code: string): Promise<ApiResponse<boolean>> {
  //   const res = await httpClient.post(`${this.baseUrl}/${code}/planogram-approval/submit`);
  //   return res.data;
  // }

  // /**
  //  * 制图审批通过
  //  */
  // async approvePlanogram(code: string, comment?: string): Promise<ApiResponse<boolean>> {
  //   const res = await httpClient.post(`${this.baseUrl}/${code}/planogram-approval/approve`, { comment });
  //   return res.data;
  // }

  // /**
  //  * 制图审批拒绝
  //  */
  // async rejectPlanogram(code: string, comment: string): Promise<ApiResponse<boolean>> {
  //   const res = await httpClient.post(`${this.baseUrl}/${code}/planogram-approval/reject`, { comment });
  //   return res.data;
  // }

  // /**
  //  * 更新Planogram状态
  //  */
  // async updateStatus(code: string, status: string): Promise<ApiResponse<boolean>> {
  //   const res = await httpClient.post(`${this.baseUrl}/${code}/status`, { status });
  //   return res.data;
  // }

  // /**
  //  * 上传Planogram图片
  //  */
  // async uploadImage(code: string, file: File): Promise<ApiResponse<{ imageUrl: string }>> {
  //   const formData = new FormData();
  //   formData.append('image', file);

  //   const res = await httpClient.post(`${this.baseUrl}/${code}/upload-image`, formData, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   });
  //   return res.data;
  // }

  // /**
  //  * 获取Planogram统计信息
  //  */
  // async getPlanogramStats(storeCode: string, shopGroupCode: string): Promise<ApiResponse<any>> {
  //   const res = await httpClient.get(`${this.baseUrl}/stats`, {
  //     params: { storeCode, shopGroupCode }
  //   });
  //   return res.data;
  // }

  // /**
  //  * 复制Planogram
  //  */
  // async copyPlanogram(code: string, newData: Partial<StoreDisplayGroupPlanogram>): Promise<ApiResponse<StoreDisplayGroupPlanogram>> {
  //   const res = await httpClient.post(`${this.baseUrl}/${code}/copy`, newData);
  //   return res.data;
  // }

  // /**
  //  * 获取Planogram历史版本
  //  */
  // async getPlanogramHistory(code: string): Promise<ApiResponse<StoreDisplayGroupPlanogram[]>> {
  //   const res = await httpClient.get(`${this.baseUrl}/${code}/history`);
  //   return res.data;
  // }

  // /**
  //  * 恢复历史版本
  //  */
  // async restoreVersion(code: string, versionId: number): Promise<ApiResponse<boolean>> {
  //   const res = await httpClient.post(`${this.baseUrl}/${code}/restore/${versionId}`);
  //   return res.data;
  // }

  /**
   * 获取Planogram完整详情（包含算法和人工结果）
   */
  async getPlanogramDetail(planogramCode: string): Promise<ApiResponse<StoreDisplayGroupPlanogram>> {
    if (USE_MOCK && WHOLE_USE_MOCK) {
      // 模拟网络延迟
      await new Promise(resolve => setTimeout(resolve, 300));
      return this.getMockPlanogramDetail(planogramCode);
    }

    const res = await httpClient.get(API_ENDPOINTS.STORE_DISPLAY_GROUPS.PLANOGRAM.QUERY_BY_CODE + '?code=' + planogramCode);
    return res.data;
  }

  /**
   * 获取算法结果详情列表
   */
  async getAlgorithmDetails(
    planogramCode: string, 
    filters?: PlanogramDetailFilters
  ): Promise<ApiResponse<StoreDisplayGroupDetailAlgorithm[]>> {
    if (USE_MOCK && WHOLE_USE_MOCK) {
      // 模拟网络延迟
      await new Promise(resolve => setTimeout(resolve, 200));
      return this.getMockAlgorithmDetails(planogramCode, filters);
    }

    const params = { ...filters };
    Object.keys(params).forEach(key => {
      if (params[key as keyof typeof params] === undefined) {
        delete params[key as keyof typeof params];
      }
    });

    const res = await httpClient.get(`${this.baseUrl}/${planogramCode}/algorithm-details`, { params });
    return res.data;
  }

  /**
   * 获取人工结果详情列表
   */
  async getManualDetails(
    planogramCode: string,
    filters?: PlanogramDetailFilters
  ): Promise<ApiResponse<StoreDisplayGroupDetailManual[]>> {
    if (USE_MOCK && WHOLE_USE_MOCK) {
      // 模拟网络延迟
      await new Promise(resolve => setTimeout(resolve, 200));
      return this.getMockManualDetails(planogramCode, filters);
    }

    const params = { ...filters };
    Object.keys(params).forEach(key => {
      if (params[key as keyof typeof params] === undefined) {
        delete params[key as keyof typeof params];
      }
    });

    const res = await httpClient.get(`${this.baseUrl}/${planogramCode}/manual-details`, { params });
    return res.data;
  }

  /**
   * 更新人工结果详情
   */
  async updateManualDetail(
    planogramCode: string,
    id: number,
    data: ManualResultEditForm
  ): Promise<ApiResponse<StoreDisplayGroupDetailManual>> {
    if (USE_MOCK && WHOLE_USE_MOCK) {
      // 模拟网络延迟
      await new Promise(resolve => setTimeout(resolve, 300));
      return this.getMockUpdateManualDetail(planogramCode, id, data);
    }

    const res = await httpClient.put(`${this.baseUrl}/${planogramCode}/manual-details/${id}`, data);
    return res.data;
  }

  /**
   * 创建人工结果详情
   */
  async createManualDetail(
    planogramCode: string,
    data: ManualResultEditForm
  ): Promise<ApiResponse<StoreDisplayGroupDetailManual>> {
    if (USE_MOCK && WHOLE_USE_MOCK) {
      // 模拟网络延迟
      await new Promise(resolve => setTimeout(resolve, 300));
      return this.getMockCreateManualDetail(planogramCode, data);
    }

    const res = await httpClient.post(`${this.baseUrl}/${planogramCode}/manual-details`, data);
    return res.data;
  }

  // ========== Mock 方法 ==========
  private getMockPlanogramDetail(planogramCode: string): ApiResponse<StoreDisplayGroupPlanogram> {
    return getMockPlanogramDetail(planogramCode);
  }

  private getMockAlgorithmDetails(
    planogramCode: string, 
    filters?: PlanogramDetailFilters
  ): ApiResponse<StoreDisplayGroupDetailAlgorithm[]> {
    return getMockAlgorithmDetails(planogramCode, filters);
  }

  private getMockManualDetails(
    planogramCode: string,
    filters?: PlanogramDetailFilters
  ): ApiResponse<StoreDisplayGroupDetailManual[]> {
    return getMockManualDetails(planogramCode, filters);
  }

  private getMockUpdateManualDetail(
    planogramCode: string,
    id: number,
    data: ManualResultEditForm
  ): ApiResponse<StoreDisplayGroupDetailManual> {
    // 这里将在Mock数据文件中实现
    return {
      traceId: 'mock-trace-id',
      success: true,
      flag: 'success' as const,
      errorMessage: null,
      data: {
        id,
        planogramCode: planogramCode,
        ...data,
        creatorAccount: 'system',
        creatorName: 'System',
        gmtCreate: new Date().toISOString(),
        modifierAccount: 'system',
        modifierName: 'System',
        gmtModified: new Date().toISOString(),
        deleted: 0
      }
    };
  }

  private getMockCreateManualDetail(
    planogramCode: string,
    data: ManualResultEditForm
  ): ApiResponse<StoreDisplayGroupDetailManual> {
    // 这里将在Mock数据文件中实现
    const newId = Date.now(); // 简单的ID生成
    return {
      traceId: 'mock-trace-id',
      success: true,
      flag: 'success' as const,
      errorMessage: null,
      data: {
        id: newId,
        planogramCode: planogramCode,
        ...data,
        creatorAccount: 'system',
        creatorName: 'System',
        gmtCreate: new Date().toISOString(),
        modifierAccount: 'system',
        modifierName: 'System',
        gmtModified: new Date().toISOString(),
        deleted: 0
      }
    };
  }

  /**
   * 手动触发执行
   */
  async manualTriggerExec(planogramId: number): Promise<ApiResponse<boolean>> {
    // 检查是否使用Mock数据
    if (USE_MOCK && WHOLE_USE_MOCK) {
      // 模拟网络延迟
      await new Promise(resolve => setTimeout(resolve, 300));
      // 返回模拟成功响应
      return {
        traceId: 'mock-trace-id',
        success: true,
        flag: 'success' as const,
        errorMessage: null,
        data: true
      };
    }

    // 实际调用后端接口
    const res = await httpClient.post(API_ENDPOINTS.STORE_DISPLAY_GROUPS.PLANOGRAM.MANUAL_TRIGGER_EXEC, { planogramId });
    return res.data;
  }
}

// 创建服务实例
const storeDisplayGroupPlanogramService = new StoreDisplayGroupPlanogramService();

export default storeDisplayGroupPlanogramService;